const PARAGRAPH_ARBITRAGE_CALCULATOR = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    type
    uuid
    id
    title
    ... on ArbitrageCalculator {
      id
      heading
      uuid
      type
      totalStakeLabel
      totalPayoutLabel
      title
      threeWayHedgePlaceholder
      threeWayHedgeLabel
      stakePlaceholder
      stakeLabel
      profitLabel
      payoutLabel
      originalBetLabel
      oddsPlaceholder
      oddsLabel
      oddsFormatOptions
      oddsFormatLabel
      marketTypesLabel
      marketTypeOptions
      linksHeading
      introduction
      hedgeLabel
      definition
      clearButtonLabel
      otherTools {
        toolIcon
        toolLink
        toolTitle
      }
    }
  }
`;

export default PARAGRAPH_ARBITRAGE_CALCULATOR;
